import React from "react";
import "../Clients/Clients.css";
import Header from "../Header/header";
import Footer from "../Footer/footer";
import IGT from "../../Assets/IGT.png";
import Nsquare from "../../Assets/Nsquare.jpg";
import Transcom from "../../Assets/transcom.png";
import Vcreate from "../../Assets/vcreate.png";
import Uber from "../../Assets/uber.png";
import Samruddha from "../../Assets/samruddha.png";

const clients = [
  {
    id: 1,
    image:IGT, 
    title: "IGT",
    description: "Designing, planning, and building infrastructure with innovation, safety, and sustainability.",
  },
  {
    id: 2,
    image: Nsquare, 
    title: "N SQUARE",
    description: "Producing goods from raw materials with efficiency and quality control.",
  },
  {
    id: 3,
    image: Transcom, 
    title: "TRANSCOM",
    description: "Selling goods and services directly to consumers with a focus on customer experience.",
  },
  {
    id: 4,
    image: Vcreate, 
    title: "Vcreate Technologies",
    description: "Selling goods and services directly to consumers with a focus on customer experience.",
  },
  {
    id: 5,
    image: Uber, 
    title: "Uber Competency",
    description: "Selling goods and services directly to consumers with a focus on customer experience.",
  },
  {
    id: 6,
    image: Samruddha, 
    title: "Samruddha Surbhi India Producer Company Ltd",
    description: "Selling goods and services directly to consumers with a focus on customer experience.",
  },
];

const Client = () => {
  return (
    <>
      <Header />
      <div className="client-container">
        <h1 className="client-title">Our Clients</h1>
        <div className="client-card-container">
          {clients.map((client) => (
            <div key={client.id} className="client-card">
              <img src={client.image} alt={client.title} className="client-image" />
              <h2 className="client-title">{client.title}</h2>
              
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Client;
